import React, { useCallback, useState } from "react";
import Document from "./Document";
import TypeToken from "./TypeToken";
import ValidationToken from "./ValidationToken";
import Password from "./Password";
import Concluded from "./Concluded";
import SideBanner from "components/layout/SideBanner";
import { Body, Container, Content } from "./styles";

const EsqueciSenhaMI = () => {
  const [step, setStep] = useState(1);
  const [userInfo, setUserInfo] = useState({});
  const [contactId, setContactId] = useState(null);

  const contact = userInfo.contacts?.find(
    (contact) => contact.contactId === userInfo?.validationContactId
  );

  const [steppers] = useState([
    "Seu documento",
    "Envio do token",
    "Validação do token",
    "Cadastro de Senha",
    "Concluído",
  ]);

  const buildComponente = useCallback(() => {
    return (
      {
        1: (
          <Document
            step={step}
            setStep={setStep}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
          />
        ),
        2: (
          <TypeToken
            step={step}
            setStep={setStep}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            setContactId={setContactId}
          />
        ),
        3: (
          <ValidationToken
            step={step}
            setStep={setStep}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            contactId={contactId}
          />
        ),
        4: (
          <Password
            step={step}
            setStep={setStep}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
          />
        ),
        5: <Concluded />,
      }[step] || (
        <Document
          step={step}
          setStep={setStep}
          userInfo={userInfo}
          setUserInfo={setUserInfo}
        />
      )
    );
  }, [step, userInfo, setUserInfo, setStep]);

  const buildHeader = (step) => {
    return (
      {
        1: {
          h1: "Esqueci minha senha",
          h2: "Informe seus dados abaixo para que possamos lhe ajudar!",
        },
        2: {
          h1: "Esqueci minha senha",
          h2: "Informe de que forma deseja receber o código",
        },
        3: {
          h1: "Insira o código",
          h2: `Informe o código enviado em seu ${
            contact?.contactType === "PHONE" ? "telefone" : "email"
          }`,
        },
        4: {
          h1: "Cadastrar nova senha",
          h2: "Lembre de atender os requisitos de segurança",
        },
        5: {
          h1: "Concluído",
          h2: "Sua senha foi alterada com sucesso",
        },
      }[step] || { h1: "", h2: "" }
    );
  };

  return (
    <Container>
      <SideBanner
        activated={step}
        header={buildHeader(step)}
        steppers={steppers}
      />
      <Content>
        <Body>{buildComponente()}</Body>
      </Content>
    </Container>
  );
};

export default EsqueciSenhaMI;
